import _map from 'lodash/map';
import React, { Component } from 'react';
import { Input, Button, Form, Select } from 'antd';
import { parseMarkdown } from '$lib/markdown';
import SUBSCRIPTION_STATUS from '@achievable-me/tundra-wizard/subscriptionStatus';
import Stackedit from 'stackedit-js';
import styles from './styles.scss';

class ContentEditForm extends Component {
  formRef = React.createRef();

  onFinish = (values) => {
    const { uuid } = this.props.contentInstance;
    this.props.updateContent({
      variables: {
        input: {
          ...values,
          uuid,
        },
      },
    });
  };

  stackEdit = () => {
    const textareaEl = document.querySelector('#markdown');
    const stackedit = new Stackedit();
    stackedit.on('fileChange', (file) => {
      const value = file.content.text;
      textareaEl.value = value;
      this.formRef.current.setFieldsValue({
        markdown: value,
      });
    });
    stackedit.openFile({
      name: 'Content',
      content: {
        text: textareaEl.value,
      },
    });
  };

  render() {
    const { contentInstance, handleDelete, loading } = this.props;
    const { availability, slug, name, markdown } = contentInstance;
    const initialValues = { availability, markdown, name, slug };

    return (
      <Form
        ref={this.formRef}
        shouldUpdate
        onFinish={this.onFinish}
        className={styles.wrapper}
        initialValues={initialValues}
      >
        {() => {
          const markdownEl = (() => {
            const markdownText = this.formRef.current
              ? this.formRef.current.getFieldValue('markdown')
              : initialValues.markdown;
            const parsedObj = parseMarkdown(markdownText, { isStaff: true });
            if (!parsedObj) {
              return null;
            }
            return parsedObj.markdownHtml;
          })();

          return (
            <>
              <Button onClick={this.stackEdit}>StackEdit</Button>
              <div className={styles.columns}>
                <div className={styles.column}>
                  <Form.Item
                    name="slug"
                    rules={[{ required: true, message: 'Slug is required' }]}
                  >
                    <Input placeholder="Chapter slug" />
                  </Form.Item>
                  <Form.Item
                    name="name"
                    rules={[{ required: true, message: 'Name is required' }]}
                  >
                    <Input placeholder="Chapter name" />
                  </Form.Item>
                  <Form.Item name="availability">
                    <Select>
                      {_map(SUBSCRIPTION_STATUS, (status) => {
                        return (
                          <Select.Option key={status} value={status}>
                            {status}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item name="markdown" noStyle>
                    <Input.TextArea
                      placeholder="Markdown"
                      className={styles.markdownFormInput}
                    />
                  </Form.Item>
                </div>
                <div className={styles.column}>{markdownEl}</div>
              </div>
              <div className={styles.actions}>
                <Form.Item>
                  <Button onClick={handleDelete} type="danger">
                    delete
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" block loading={loading}>
                    Update
                  </Button>
                </Form.Item>
              </div>
            </>
          );
        }}
      </Form>
    );
  }
}

export default ContentEditForm;
